import apiFetch from '../apiFetch'

export default function (values, token)  {  
  return apiFetch({endPoint: `Pool/insertPoolPIC`,method: 'POST', body: values, token: token})
}